import BasicLayout from '@components/layout/BasicLayout'
import FullScreenSection from '@components/layout/FullScreenSection'
import PageSeo from '@components/seo/PageSeo'
import getFAQ from '@operations/queries/getFAQData'
import getPage from '@operations/queries/getPage'
import getSiteSettings from '@operations/queries/getSiteSettings'
import { maxWidthQueries, minWidthQueries } from '@operations/utils/useMediaQuery'
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

const PageWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 100vh;
  width: 100vw;
  background: linear-gradient(45deg, #171717, #303030);
`
const StyledFaqHeaderText = styled.h2`
  margin: 10px;
  font-weight: bold;
`

const AnswerWrapper = styled.div`
  background: black;
  max-height: 10px;
  opacity: 0;
  transition: max-height 0.1s linear;
  border-radius: 0 0 20px 20px;
`
const AnswerText = styled.p`
  font-size: 2em;
  padding: 10px;
  color: aliceblue;
  display: flex;
`

const AnimateHeight = styled.div`
  min-height: 60px;
  width: 65%;
  background: white;
  display: flex;
  margin: 20px;
  border-radius: 20px;
  flex-direction: column;

  :hover {
    box-shadow: 10px 10px 10px lightblue;
    ${AnswerWrapper} {
      transition-delay: 0.25s;
      transition: 0.5s;
      opacity: 1;
      max-height: 1000px;
    }
  }

  @media ${maxWidthQueries.sm} {
    width: 100%;
    border-radius: 10px;
    ${AnswerWrapper} {
      border-radius: 10px;
      height: auto;
    }
  }
`

const FAQHeader = styled.h1`
  font-size: 3em;
  color: aliceblue;
  padding-top: 100px;
`

const Faq = ({ data: { faq, page, siteSettings } }) => {
  const elementRef = useRef([])

  return (
    <BasicLayout
      footerLinks={siteSettings?.footerLinks}
      footerLogo={siteSettings?.footerLogo?.url}
      headerLinks={siteSettings?.headerLinks}
      headerLogo={siteSettings?.logo?.url}
    >
      <PageWrap>
        <div>
          <FAQHeader>FAQ</FAQHeader>
        </div>

        {faq?.faq.map(({ id, question, answer }) => {
          return (
            <AnimateHeight key={id}>
              <StyledFaqHeaderText>{question}</StyledFaqHeaderText>

              <AnswerWrapper
                ref={element => {
                  elementRef.current[id] = element
                }}
              >
                <AnswerText>{answer}</AnswerText>
              </AnswerWrapper>
            </AnimateHeight>
          )
        })}
      </PageWrap>
    </BasicLayout>
  )
}

export const getStaticProps = async () => {
  let page
  let siteSettings
  let faq
  if (process.env.API_URL) {
    page = await getPage('Faq')
    siteSettings = await getSiteSettings()
    faq = await getFAQ()
  }

  return {
    props: {
      data: {
        faq: faq || null,
        page: page?.[0] || null,
        siteSettings: siteSettings || null,
      },
    },
    revalidate: false,
  }
}

export default Faq
